import PropTypes from 'prop-types';
import { Component } from 'react';
import Flux from '../../flux/Flux';
import { VXPay, VXPayAction } from '../../utils/VXPay';

class FeedPostHeaderFavorite extends Component {
	constructor(props) {
		super(props);

		this.actorNote = null;

		this.state = {
			isFavorite: this.props.isFavorite,
		};

		this.togglePin = this.togglePin.bind(this);
		this.onPinChange = this.onPinChange.bind(this);
	}

	componentDidMount() {
		Flux.Favorite.addActorPinnedListener(this.onPinChange);
		Flux.Favorite.addActorUnpinnedListener(this.onPinChange);
	}

	componentWillUnmount() {
		Flux.Favorite.removeActorPinnedListener(this.onPinChange);
		Flux.Favorite.removeActorUnpinnedListener(this.onPinChange);
	}

	/**
	 * @param {Number}  actorId
	 * @param {Boolean} isFavorite
	 */
	onPinChange(actorId, isFavorite) {
		if (this.props.actorId === actorId) {
			this.setState({
				isFavorite: isFavorite,
			});
		}
	}

	togglePin(e) {
		e.preventDefault();
		e.stopPropagation();
		if (Flux.Guest.isLoggedIn()) {
			if (this.state.isFavorite) {
				Flux.Favorite.unpinActor(this.props.actorId);
				this.setState({ isFavorite: false });
			} else {
				Flux.Favorite.pinActor(this.props.actorId);
				this.setState({ isFavorite: true });
			}
		} else {
			const action = new VXPayAction(Flux.Constants.ActionTypes.Notification.FAVORITE_PIN_ACTOR, {
				targetId: this.props.actorId,
			});
			VXPay.openSignupOrLogin(
				{
					host: this.props.actorId,
				},
				action,
			);
		}
	}

	render() {
		if (this.state.isFavorite) {
			return <span onClick={this.togglePin} className="icon -icon-heart-full feed-heart"></span>;
		}
		return <span onClick={this.togglePin} className={'icon -icon-heart-line feed-heart'}></span>;
	}
}

FeedPostHeaderFavorite.propTypes = {
	actorId: PropTypes.number.isRequired,
	isFavorite: PropTypes.bool,
};

FeedPostHeaderFavorite.defaultProps = {
	isFavorite: false,
};

export default FeedPostHeaderFavorite;
